import { loanConsentsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_CONSENTS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/consents`,
  {
    GET_APPLICATION_CONSENTS: 'GET_APPLICATION_CONSENTS',
  },
);

export const getApplicationConsentsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanConsentsApi.getApplicationConsents(params);

  return dispatch({
    type: LOAN_CONSENTS_ACTION_TYPE.GET_APPLICATION_CONSENTS,
    payload: data,
  });
});
